import { render } from "./PengumumanView.vue?vue&type=template&id=180b47bf"
import script from "./PengumumanView.vue?vue&type=script&lang=js"
export * from "./PengumumanView.vue?vue&type=script&lang=js"

import "./PengumumanView.vue?vue&type=style&index=0&id=180b47bf&lang=css"
import "./PengumumanView.vue?vue&type=style&index=1&id=180b47bf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__